//import Store from "./Store.js";
import {getDevice} from "./lib.js";
//import AI from "./AI.js";
//import Peace from "./Peace.js";
//import Grid  from "./Grid.js"
//import Stage from "./Stage.js"
//import Random from "./Random.js"

// Menu state
export default class MenuState extends Phaser.Scene {
  // Init
  constructor () {
    super({ key: 'MenuState', active: false });
    //this.grid = new Grid(6, 6);
    //this.stage = new Stage(10);
    //this.maxsum = 10;
    this.logictype = 'typeB'
    this.start = false;//２度押し禁止用
  
  }
  
  // Preload
  preload () {
    
  }
  
  // Create
  create () {
    this.add.image(this.cameras.main.width/2,this.cameras.main.height/2, 'img_title_bg')
    .setDisplaySize(this.cameras.main.width,this.cameras.main.height);
    if(GameConfig.debug)
    this.add.text(12, 1, 'V.1.8', { fill: '#f00' });
    //se
    //start
    //restart
    //home
    // this.scoreText = this.add.text(Piles.pile_positions['foundation_0'].x - Piles.card_width/2, 12, '', { fontSize: '16px', fill: '#FFF' });
    //var stock = new Card(this, 0, 0);
    //stock.x = Piles.pile_positions['stock'].x + Piles.card_width/2;
    //stock.y = Piles.pile_positions['stock'].y;

    //this.add.sprite(Piles.pile_positions['foundation_0'].x + 30, 15,'img_time').setScale(0.8);
    // PC or SmartPhone
    var dev = getDevice();
    //調整用
    var _y = this.cameras.main.height/4 - this.cameras.main.height/6;
   
    var _ofsty = 30 + _y
    if (dev == "sp" || dev == "iPad") {
      var start1_btn = this.add.sprite(this.cameras.main.width/2,this.cameras.main.height/2 + 65*0 + _ofsty,'img_start');
      //var start2_btn = this.add.sprite(this.cameras.main.width/2,this.cameras.main.height/2 + 65*1 + _ofsty,'normal_start');
      //var start3_btn = this.add.sprite(this.cameras.main.width/2,this.cameras.main.height/2 + 65*2 + _ofsty,'hard_start');
      var help_btn = this.add.sprite(this.cameras.main.width/2,this.cameras.main.height/2 + 65*1 + _ofsty,'img_help');  
      var home_btn = this.add.sprite(this.cameras.main.width/2,this.cameras.main.height/2 + 65*2 + _ofsty,'img_btn_home');  
    }else{
      var start1_btn = this.add.sprite(this.cameras.main.width/2,this.cameras.main.height/2 + 65*0 + _ofsty,'img_start');
      //var start2_btn = this.add.sprite(this.cameras.main.width/2,this.cameras.main.height/2 + 65*1 + _ofsty,'normal_start');
      //var start3_btn = this.add.sprite(this.cameras.main.width/2,this.cameras.main.height/2 + 65*2 + _ofsty,'hard_start');
      var help_btn = this.add.sprite(this.cameras.main.width/2,this.cameras.main.height/2 + 65*1 + _ofsty,'img_help');
    }


/*
    var soundflg = localStorage.getItem("game4_logic");
    if(soundflg){
      this.logictype = soundflg;
    }else{
      this.logictype = 'typeA'
    }
    */
    /*
    var debugBack = this.add.graphics();
    debugBack.fillStyle(0xFFFFFF, 1);
    debugBack.fillRect(this.cameras.main.width/2-100,this.cameras.main.height/2 + 65*4 + _ofsty, 30, 18 + 10);

    this.hintBtn = this.add.text(this.cameras.main.width/2-100,this.cameras.main.height/2 + 65*4 + _ofsty, '□', { fontSize: '24px', fill: '#000' });
    this.hintBtn.setInteractive();
    this.hintBtn.on('pointerdown', () => {
      if(this.logictype == 'typeA'){
        this.logictype = 'typeB'
      }else{
        this.logictype = 'typeA'
      }
      if(this.logictype == 'typeA'){
        this.hintBtn.setText('□')
      }else{
        this.hintBtn.setText('■')
      }
      localStorage.setItem("game4_logic",this.logictype);
    });
    if(this.logictype == 'typeA'){
      this.hintBtn.setText('□')
    }else{
      this.hintBtn.setText('■')
    }
    this.add.text(this.cameras.main.width/2-100+40,this.cameras.main.height/2 + 65*4 + _ofsty, 'パネル選択ロジック', { fontSize: '24px', fill: '#000' });
    */
    var title = this.add.sprite(this.cameras.main.width/2, this.cameras.main.height/2 - 80 + _y,'img_title').setScale(0.8);
    //this.add.text(this.cameras.main.width/2-100, this.cameras.main.height/2 - 110, '足し算（仮名）', { fontSize:'24px',fill: '#f00' });
   
    var joker = this.add.sprite( this.cameras.main.width/2, this.cameras.main.height/4 ,'img_fukurou');
    joker.y = this.cameras.main.height/5;
    joker.setScale(0.4)
    //・ふくろうの絵は、胴体の中心Ｘ座標が画面の中心になるようにして下さい。
    joker.x -= Math.floor(joker.displayWidth * 13/160)
   /*  var debugBack = this.add.graphics();
    debugBack.fillStyle(0xFFFFFF, 1);
    debugBack.fillRect(this.cameras.main.width/2-50,0, 100, joker.y-(joker.displayHeight/3));

    debugBack = this.add.graphics();
    debugBack.fillStyle(0xFFFFFF, 1);
    debugBack.fillRect(this.cameras.main.width/2-50,this.cameras.main.height-(joker.y-(joker.displayHeight/3)),100,100);
 */
    this.soundobj = this.sound.add("se_decision3");
    start1_btn.setInteractive();
    start1_btn.on('pointerdown', () => { 
        if(GameConfig.sound){
          /*if(this.game.sound.context.state === 'suspended') { 
            this.game.sound.context.resume();  
          }*/
          //this.soundobj.play("",0,1,true);
          //this.sound.play('se_decision3');
          this.sound.play('se_start')
        }
        //if(!this.start){
          this.start = true;
          this.scene.start('GameState' , { level: '10' ,logic:this.logictype});
        //}
    },this);
    /*
    start2_btn.setInteractive();
    start2_btn.on('pointerdown', () => { 
      if(GameConfig.sound){
        
        this.sound.play('se_decision5');
      }
      this.scene.start('GameState' , { level: '20' ,logic:this.logictype});
    },this); 
    start3_btn.setInteractive();
    start3_btn.on('pointerdown', () => { 
      if(GameConfig.sound){
      //this.soundobj.play("",0,1,true);
      this.sound.play('se_decision5');
      }
      this.scene.start('GameState' , { level: '30' ,logic:this.logictype});
     // Store.level = 3;
     // this.createStage()
      //this.scene.start('GameState', { level: '20' ,logic:this.logictype});
    },this);
*/
    this.setPauseMenu();
    help_btn.setInteractive();
    help_btn.on('pointerdown', () => { 
      this.pauseMenu.setVisible(true);
      if(GameConfig.sound){
        this.sound.play('se_decision3');
      }
    },this);
    if (home_btn) {
      home_btn.setInteractive();
      home_btn.on(
        "pointerdown",
        () => {
          if (GameConfig.sound) {
            this.sound.play("se_decision3");
          }
          window.location.href = GameConfig.homeurl;
        },
        this
      );
    }
  }

  setPauseMenu(){
    this.pauseMenu = new Phaser.GameObjects.Container(this,this.cameras.main.width/2,this.cameras.main.height/2);
    var progressBox =  new Phaser.GameObjects.Graphics(this);
    progressBox.fillStyle(0x000000, 0.5);
    progressBox.fillRect(-this.cameras.main.width/2,-this.cameras.main.height/2, this.cameras.main.width,this.cameras.main.height);
    this.pauseMenu.setSize(this.cameras.main.width,this.cameras.main.height);
    this.pauseMenu.add(progressBox);
    this.pauseMenu.setDepth(1000);
    var cleamenu0  =  new Phaser.GameObjects.Sprite(this,0,0);
    cleamenu0.setTexture('img_manual');
    this.pauseMenu.add(cleamenu0);
    this.add.existing(this.pauseMenu);
    var _y = cleamenu0.height/2;
    cleamenu0  =  new Phaser.GameObjects.Sprite(this,0,_y);
    cleamenu0.setTexture('img_btn_tojiru');
    this.pauseMenu.add(cleamenu0);
    this.add.existing(this.pauseMenu);

    cleamenu0.setInteractive();
    cleamenu0.on('pointerdown', () => { 
      this.pauseMenu.setVisible(false);
    });
    this.pauseMenu.setInteractive();
    this.pauseMenu.on('pointerdown', (pointer, localX, localY, event) => { 
      event.stopPropagation();
    });
    this.pauseMenu.setVisible(false);
  }

  // Update
  update() {
    

  //this.scoreText.setText(this.timeStr);
    
    // Display current level
    //this.gameNumText.setText('');//"GAME:" + this.game_number);
  }
  createStage() {
    this.stage.createStage();
  }
}

